export enum JobTypes {
  patients = 'patients',
  accounts = 'accounts',
}
